export interface DayOffResponse {
  leaveCategory: string;
  leaveCategoryDescription: string;
  leaveType: string;
  status: string;
}

export interface TimeKeepingResponse {
  checkInTime: string;
  checkOutTime: string;
  lateDuration: number;
  earlyLeaveDuration: number;
  lateRequest: number;
  earlyLeaveRequest: number;
  dayOffList: DayOffResponse[];
}

export interface ArriveLateResponse {
  id: string;
  registerDate: string;
  type: string;
  dayOffs: string;
  totalMinutes: number;
  reason: string;
  relatedPersonName: string;
  approveName: string;
  status: string;
  refuseReason: string | null;
  approveDate: string | null;
}

export enum ConfirmStatus {
  READY = "READY",
  NOT_READY = "NOT_READY",
  CONFIRMED = "CONFIRMED",
  EXPIRED_DATE = "EXPIRED_DATE",
  REFUSED = "REFUSED",
  APPROVE = "APPROVE",
  AUTO_APPROVED = "AUTO_APPROVE",
}

export interface TimeKeepingMonthResponse {
  confirmStatus: ConfirmStatus | string;
  leaveReasons: [
    {
      reasonCode: string;
      reasonName: string;
      totalDays: number;
    },
  ];
  message: string;
  totalWorkDays: number;
  workDays: {
    [key: string]: string;
  };
  fromDate: string;
  toDate: string;
}
